import styled from 'styled-components'
import { theme } from '../../../styles/theme'

export const Label = styled.label`
  margin-bottom: 8px;
  margin-top: 0;
  width: 100%;

  position: absolute;
  top: 6px;
  left: 15px;
  z-index: 1;

  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  font-family: ${theme.font.inter};
  line-height: ${theme.font.sizes.normal};
  letter-spacing: -0.02em;
  color: ${theme.colors.gray500};

  & > span {
    margin-left: 5px;
    font-family: ${theme.font.inter};
    font-weight: ${theme.font.medium};
    font-size: ${theme.font.sizes.small};
    line-height: ${theme.font.sizes.normal};
    letter-spacing: -0.02em;
    color: ${theme.colors.erro};
  }
  @media (min-width: 768px) {
    top: 10px;
    left: 10px;
    font-size: 12px;
  }
`
